export default {
  SET_TAGS(state, sd_status) {
    state.sd_status = sd_status
  },
  REMOVE_TAG(state, itemId) {
      const sd_statusIndex = state.sd_status.datas.findIndex((u) => u.id == itemId)
      state.sd_status.datas.splice(sd_statusIndex, 1)
  },
  SELECTED_TAG(state,data){
    state.sd_status.datas = []
    state.sd_status.total = 1;
    state.sd_status.per_page = 1;
    state.sd_status.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.sd_status = data
  },
  ADD_ITEM(state,data){
    state.sd_status = data
  },
}
